import type { LDContext } from 'launchdarkly-js-client-sdk';

// Both shapes give the LaunchDarkly user a `roles` attribute holding the Auth0
// roles, so a flag can target a role, eg "roles is one of driver".
export const buildLaunchDarklyContext = ({
  email,
  roles,
  warehouseId,
}: {
  email: string;
  roles: string[];
  warehouseId?: string;
}): LDContext => {
  if (!warehouseId) {
    // Preserve the legacy user payload when there is no warehouse. The SDK
    // drops unknown top-level attributes from legacy users, so roles go in
    // `custom`, which it flattens into top-level user attributes.
    return { key: email, custom: { roles } };
  }

  return {
    kind: 'multi',
    user: {
      key: email,
      // The SDK normalized the previous `custom.warehouseId` user payload to
      // this top-level attribute. Keep it so existing user-context rules work
      // unchanged while the warehouse context below enables individual
      // warehouse targeting.
      warehouseId,
      roles,
    },
    warehouse: {
      key: warehouseId,
    },
  };
};
